export default "__VITE_ASSET__93407de4__"